import { jsx } from 'react/jsx-runtime';
import { CommandGroup } from 'cmdk';
import { forwardRef, useId } from 'react';
import { SingleSelectGroupContextProvider } from '../../contexts/group-context.mjs';

const SingleSelectGroup = forwardRef(({ title, ...props }, forwardedRef) => {
  const groupId = useId();
  return /* @__PURE__ */ jsx(SingleSelectGroupContextProvider, { id: groupId, children: /* @__PURE__ */ jsx(
    CommandGroup,
    {
      "aria-labelledby": groupId,
      "data-scope": "single-select",
      "data-part": "group",
      heading: title,
      ref: forwardedRef,
      ...props
    }
  ) });
});

export { SingleSelectGroup as SelectGroup };
//# sourceMappingURL=Group.mjs.map
